import isArray from 'lodash/isArray';

export function parseDataKey(key: string | string[]) {
  if (isArray(key)) {
    return key.join('/');
  }
  if (typeof key === 'string') {
    return key;
  }
  return String(key);
}
